async function addToCart(variant_id) {
  let formData = {
     'items': [{
         'id': variant_id,
         'quantity': 1
      }]
  };
  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {        
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};
document.addEventListener("DOMContentLoaded", function(event) {
  if ($('.cdi_popup.cdi_offer').length > 0){
    setTimeout(function() {
      risePopup('.cdi_popup.cdi_offer');
      $('.cdi_popup.cdi_offer .cdi_popup_content.cdi_direct').on('click', '.ProductForm__AddToCart', function (){
        let variant_id = $('.cdi_popup.cdi_offer .cdi_popup_content.cdi_direct.swiper-slide-active').attr('data-offer-id');
        if ($('.cdi_popup.cdi_offer').length === 1) {          
          variant_id = $('.cdi_popup.cdi_offer .cdi_popup_content.cdi_direct').attr('data-offer-id');
        }
        let response = addToCart(variant_id);
        setTimeout(() => { location.reload(); }, 1000);
      });
    }, $('.cdi_popup.cdi_offer').attr('data-delay'));
  }
});